var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTheStoryBehind(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.0718 6.49844C51.9653 6.49844 53.5004 8.03347 53.5004 9.92702V40.7841C53.5004 42.6777 51.9653 44.2127 50.0718 44.2127H46.6432V54.4984L36.3575 44.2127H8.92894C7.03539 44.2127 5.50037 42.6777 5.50037 40.7841V9.92702C5.50037 8.03347 7.03539 6.49844 8.92894 6.49844H50.0718ZM50.0726 9.92777H8.92969V40.7849H38.0726L43.2154 45.9277V40.7849H50.0726V9.92777ZM32.9293 30.4999V33.9285H15.7865V30.4999H32.9293ZM43.215 23.6413V27.0698H15.7865V23.6413H43.215ZM43.215 16.7827V20.2112H15.7865V16.7827H43.215Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTheStoryBehind);
export default __webpack_public_path__ + "static/media/theStoryBehind.f32e7234.svg";
export { ForwardRef as ReactComponent };